export const Data = [
  {
    type: "zh",
    gsxwTitle:"公司新闻",
    gsxwMore:"查看更多",
    gsxwItem:[
      {
        imgUrl:"https://www.victrum.com/image/sy/news1.jpg",
        text1:"2024年3月19日",
        text2:"口腔 Er:YAG激光治疗仪... ",
        text3:"了解更多",
        indexPath:"gss",
        backcolor:"#FFFFFF"
      },
      {
        imgUrl:"https://www.victrum.com/image/sy/news2.jpg",
        text1:"2024年3月20日",
        text2:"2024年东北国际口腔..",
        text3:"了解更多",
        indexPath:"gxx",
        backcolor:"#FFFFFF"
      },
      {
        imgUrl:"https://www.victrum.com/image/sy/news3.jpg",
        text1:"2024年3月27日",
        text2:"微创未来 3月郑州有请",
        text3:"了解更多",
        indexPath:"gyy",
        backcolor:"#FFFFFF"
      }
    ]
  },
  {
    type: "en",
    gsxwTitle:"Company News",
    gsxwMore:"View More",
    gsxwItem:[
      {
        imgUrl:"https://www.victrum.com/image/sy/news1.jpg",
        text1:"March 19, 2024",
        text2:"Er:YAG Laser Treatment... ",
        text3:"Learn More",
        indexPath:"gss",
        backcolor:"#FFFFFF"
      },
      {
        imgUrl:"https://www.victrum.com/image/sy/news2.jpg",
        text1:"March 20, 2024",
        text2:"The Grand Opening of th...",
        text3:"Learn More",
        indexPath:"gxx",
        backcolor:"#FFFFFF"
      },
      {
        imgUrl:"https://www.victrum.com/image/sy/news3.jpg",
        text1:"March 27, 2024",
        text2:"Micro-Innovation | Marc...",
        text3:"Learn More",
        indexPath:"gyy",
        backcolor:"#FFFFFF"
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/js/image/gsxw.js